import React, {useContext, useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Card,
    Col,
    ConfigProvider,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Modal, Popover,
    Row,
    Select, Table,
    TableColumnsType, Tag
} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiMessage, BiTrash, BiX} from "react-icons/bi";
import {Escola} from "../../../../model/root/Escola";
import {GetInscripcionsEscoles} from "../../../../dao/inscripcions/GetInscripcionsEscoles";
import {AuthContext} from "../../../../config/AuthContext";
import TextArea from "antd/es/input/TextArea";
import Activitat from "../../../../model/multilleure/casals/Activitat";
import Casal from "../../../../model/inscripcions/Casal";
import dayjs from "dayjs";
import {GetActivitats} from "../../../../dao/multilleure/GetActivitats";
import {CloseOutlined} from "@ant-design/icons";
import {PostCasal} from "../../../../dao/multilleure/casals/PostCasal";
import locale from "antd/es/locale/es_ES";
import {BsCash, BsPencil, BsPersonAdd, BsTicket} from "react-icons/bs";
import AutoritzatModal from "../../../inscripcions/components/AutoritzatModal";

interface IngredientModalProps {
    element: any;
    onClose: (value: boolean) => void;
    visible: boolean;
    editar: boolean;
    idInsc: string;
}

const ContactesModal: React.FC<IngredientModalProps> = ({element, onClose, visible, editar, idInsc}) => {

    const format = 'DD-MM-YYYY';

    useEffect(() => {
        console.log(JSON.stringify(element.contactes));
    }, []);

    const handleCancel = () => {
        onClose(false);
    };


    const columns2: TableColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 30
        },
        {
            key: 'nomComplet',
            title: 'Nom Contacte',
            dataIndex: 'nomComplet',
            width: 30,
            render: (infant, ele) => (
                 <Tag key={ele.key} color={Colors.colors.color5}>
                    {ele.nomComplet}
                </Tag>
            )
        },
        {
            key: 'email',
            title: 'Email',
            dataIndex: 'email',
            width: 30
        },
        {
            key: 'parentesc',
            title: 'Parentesc',
            dataIndex: 'parentesc',
            width: 30
        },
        {
            key: 'dni',
            title: 'DNI',
            dataIndex: 'dni',
            width: 30
        },
        {
            key: 'telefons',
            title: 'Telèfons',
            dataIndex: 'telefons',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={Colors.colors.color1}>{ele.telefon !== "0" ? ele.telefon : ""}</Tag>
                    <Tag color={Colors.colors.color3}>{ele.telefon2 !== "0" ? ele.telefon2 : ""}</Tag>
                    <Tag color={Colors.colors.color4}>{ele.telefon3 !== "0" ? ele.telefon3 : ""}</Tag>
                </>
            ),
        }
    ];

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="CASAL"
            open={visible}
            onCancel={handleCancel}
            footer={[]}
            width={1000}
        >
            <Table columns={columns2} dataSource={element.contactes} pagination={false}/>
        </Modal>
        </ConfigProvider>
    );
};

export default ContactesModal;
